export const mapTypesButtons = [
  {
    type: 'location',
    label: 'Locations',
  },
  {
    type: 'event',
    label: 'Incidents',
  },
];

